<nav role="navigation" class="filters">
    <form>
        <button #filtersReset kuiButton [size]="'large'" [danger]="false" [type]="'primary'"
            style="margin-bottom: 25px;" type="button" class="screen-lg-xl reset-filter"
            [class.reset-filter-disabled]="disableReset" [disabled]="disableReset" (click)="resetFilters($event)">{{
            'reset_filter' | translate }}</button>
        <ul class="filter-list">
            <li id="{{filterItem.filterField}}" [ngClass]="{'md': screenWidth === 'MD', 'sm': screenWidth === 'SM'}"
                class="filter-item medium-6 small-12"
                *ngFor="let filterItem of productFilter; let filterItemIndex = index;">
                <ng-container
                    *ngIf="((filterItem.displayName !== 'price' && filterItem.displayName !== 'max_q')  || filterItem.defaultMinRangeVal !== filterItem.defaultMaxRangeVal) ||  (filterItem.displayName == 'max_q' && showMaxQ)">
                    <div kuiText class="filterTitle">
                        {{ filterItem.displayName | lowercase | translate }}
                    </div>
                    <!--gpu-->
                    <ng-container *ngIf="filterItem.fieldType === 'checkbox' && filterItem.displayName === 'gpu'">
                        <div class="filterContent">
                            <ng-container *ngFor="let groupvalues of productFilterGroup; let groupFilterIndex = index">
            <li class="filterValue subList" *ngIf="groupvalues.units !== 0">
                <div class="filterValuesContent">
                    <label class="filterCheck">
                        <input kuiCheckbox type="checkbox" [id]="groupvalues.displayName" name="" value=""
                            [checked]="groupvalues.checked" [disabled]="groupvalues.units == 0"
                            (change)="changedGroup(groupFilterIndex, groupvalues, $event.currentTarget.checked)">
                        <span class="checkmarkbox"></span>
                        <span kuiText class="value-name ">{{groupvalues.displayName | translate }}</span>
                    </label>
                    <b class="subListMore"
                        [class.listLess]="showMoreGroup(groupFilterIndex,groupvalues) || groupvalues.units == 0"
                        (click)="toggleGroupFilter(groupFilterIndex,groupvalues?.length)"></b>
                    <span kuiText class="values-count">({{groupvalues.units}})</span>
                </div>
                <ul class="filterValueBlock subBlock"
                    *ngIf="!showMoreGroup(groupFilterIndex,groupvalues) && groupvalues.units !=0"
                    style="display: block">
                    <ng-container *ngFor="let values of filterItem?.filterValues ; let i = index;">

                        <li id='{{values.dispValue}}'
                            *ngIf='values.dispValue !="GPU" && values.groupType+"_group"===groupvalues.displayName && values.units !=0'
                            class="filterValue subList">

                            <div class="filterValuesContent">
                                <label class="filterCheck" for="{{filterItem.filterField}}-{{i}}">
                                    <input kuiCheckbox type="checkbox" [disabled]="values.units == -1"
                                        id="{{filterItem.filterField}}-{{i}}" name="{{filterItem.filterField}}-{{i}}"
                                        (change)="changed(filterItem, values, $event.currentTarget.checked)"
                                        [value]="values.checked" [checked]="values.checked" />
                                    <span class="checkmarkbox"></span>
                                    <span kuiText class="value-name"
                                        *ngIf="filterItem.filterField !== 'customer_rating_filter' && filterItem.dataType !== 'Boolean'">{{values.dispValue}}</span>
                                </label>
                                <span class="values-count">({{values.units}})</span>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </li>
            </ng-container>
            </div>
            </ng-container>
            <!-- gpu-->
            <ng-container *ngIf="filterItem.fieldType === 'checkbox' && filterItem.displayName !== 'gpu'">
                <div class="filterContent">
                    <ul class="filterValueBlock">
                        <ng-container
                            *ngFor="let values of filterItem?.filterValues | slice:0:getMaxToShow(filterItemIndex, filterItem?.filterValues); let i = index;">
                            <li id='{{values.dispValue}}' class="filterValue"
                                *ngIf="values.units!==0 || (filterItem.displayName == 'max_q')">
                                <div class="filterValuesContent">
                                    <label class=""
                                        [ngClass]="{'filterCheck': filterItem.displayName !== 'category' , 'filterRadio':filterItem.displayName === 'category'}"
                                        for="{{filterItem.filterField}}-{{i}}">

                                        <input kuiCheckbox *ngIf="filterItem.displayName !== 'category'" type="checkbox"
                                            id="{{filterItem.filterField}}-{{i}}"
                                            [disabled]="values.units == 0 && filterItem.displayName !== 'max_q'"
                                            name="{{filterItem.filterField}}-{{i}}"
                                            (change)="changed(filterItem, values, $event.currentTarget.checked)"
                                            [value]="values.checked" [checked]="values.checked" />

                                        <input kuiRadio *ngIf="filterItem.displayName === 'category'" type="radio"
                                            id="{{filterItem.filterField}}-{{i}}" [disabled]="values.units == -1"
                                            name="{{filterItem.filterField}}-{{i}}"
                                            (change)="changed(filterItem, values, $event.currentTarget.checked)"
                                            [value]="values.checked" [checked]="values.checked" />


                                        <span
                                            [ngClass]="{'checkmarkbox': filterItem.displayName !== 'category' , 'checkRadio':filterItem.displayName === 'category'}"></span>

                                        <span kuiText class="value-name"
                                            *ngIf="filterItem.filterField !== 'customer_rating_filter' && filterItem.dataType !== 'Boolean'">{{values.dispValue
                                            | translate}}</span>
                                        <!-- <span class="value-name"
                                                                            *ngIf="filterItem.filterField !== 'customer_rating_filter' && filterItem.dataType !== 'Boolean'">{{filterItem.displayName + '_' + values.dispValue | lowercase | translate}}</span> -->
                                        <span kuiText
                                            *ngIf="filterItem.filterField !== 'customer_rating_filter' && filterItem.dataType === 'Boolean'">{{values.dispValueDesription
                                            | translate}}</span>
                                        <rating-generator *ngIf="filterItem.filterField === 'customer_rating_filter'"
                                            [points]="values.dispValue"></rating-generator>
                                    </label>
                                    <ng-container *ngIf="filterItem.displayName !== 'hd_storage_size'">
                                        <span kuiText *ngIf="filterItem.showCount"
                                            class="values-count">({{values.units}})</span>
                                    </ng-container>
                                </div>
                                <div *ngIf="(i === getMaxToShow(filterItemIndex) - 1) && (filterItem.filterValues?.length > maxToShow)"
                                    [class.show-more-content]="showMore(filterItemIndex, filterItem?.filterValues)"
                                    [class.show-less-content]="!showMore(filterItemIndex, filterItem?.filterValues)"
                                    (click)="toggleShowMoreLess(filterItemIndex, filterItem.filterValues?.length)">
                                    <span kuiText class="title">{{getShowMoreLessLabel(filterItemIndex) |
                                        translate}}</span>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </ng-container>
            <ng-container *ngIf="filterItem.fieldType === 'range'">
                <div class="filter-content">
                    <range-slider [screenWidth]="screenWidth" [rangeSliderInput]="filterItem"
                        (filterRangeInputChange)="changed(type, range, $event)"></range-slider>
                </div>
            </ng-container>
            </ng-container>
            </li>
        </ul>
    </form>
</nav>